import React from "react";
import aboutStyle from "../../style/body/About.module.css";
import IconShow from "../helperComponents/Icon";
import PersonalInfo from "./helper-component/personalInfo";
import InterestCard from "./helper-component/InterestAbout";
import HeadLine from "./helper-component/HeadLine";

const About = () => {
  return (
    <div className="container">
      <div className={`row ${aboutStyle.row_1}`}>
        <div
          className={`col-lg-3 col-12 container-center ${aboutStyle.dp_column}`}
        >
          <div className={` ${aboutStyle.dp_container}`}>
            <img src="assets/images/DP.png" alt="Display Image" />
          </div>
          <h3>Md. Moshiul Azam</h3>
          <h6>Software Engineer</h6>
          <div className={`col-lg-1 ${aboutStyle.about_icons_row}`}>
            <IconShow
              path="mailto:azammoshiul8@gmail.com"
              className={`${aboutStyle.side_icon}`}
              src="assets/icons/about-icons/email.svg"
            />
            <IconShow
              path="https://bd.linkedin.com/in/moshiulazamm"
              className={`${aboutStyle.side_icon}`}
              src="assets/icons/about-icons/linkedin.svg"
            />
            <IconShow
              path="https://github.com/moshiul45"
              className={`${aboutStyle.side_icon}`}
              src="assets/icons/about-icons/github.svg"
            />
            <IconShow
              path="https://www.researchgate.net/profile/Md-Azam-28"
              className={`${aboutStyle.side_icon}`}
              src="assets/icons/about-icons/researchgate.svg"
            />
          </div>
        </div>
        <div className="col-lg-9 col-md-11">
          <div className={`${aboutStyle.flex_container}`}>
            <div className={`col-lg-11 col-12 ${aboutStyle.about_passage}`}>
              <div className={`row  ${aboutStyle.about_para}`}>
                <div
                  className={`col-md-1 col-12 ${aboutStyle.double_quotation_div}`}
                >
                  <img
                    className={`${aboutStyle.double_quotation}`}
                    src="assets/icons/about-icons/double-quotation.svg"
                  ></img>
                </div>
                <div className={`col-md-11 col-12`}>
                  <p className={`${aboutStyle.justify_text}`}>
                    <br />A devoted software engineer with a solid foundation in
                    computer science. My journey began as a CSE graduate, and
                    I've since flourished in the world of software engineering,
                    specializing in Node.js, R&D, database management, and AWS
                    deployment. My genuine passion is problem-solving, which
                    makes each coding challenge an exciting opportunity. As I
                    embark on the path to post-graduation, I am eager to delve
                    deeply into the fields of blockchain and software
                    engineering, driven by a desire for mentorship and a thirst
                    for cutting-edge knowledge.
                  </p>
                  <div className={`${aboutStyle.personalInfo}`}>
                    <div className={`${aboutStyle.personalInfo_div}`}>
                      <div className={`row`}>
                        <PersonalInfo
                          title="Birthday"
                          value="15th September 1998"
                        />
                        <PersonalInfo
                          title="Email"
                          url="mailto:azammoshiul8@gmail.com"
                          value="azammoshiul8@gmail.com"
                        />
                      </div>
                      <div className="row">
                        <PersonalInfo
                          title="Address"
                          value="Dhaka, Bangladesh"
                        />
                        <PersonalInfo
                          title="Phone"
                          url="tel:+880 1631925038"
                          value="+880 1631925038"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-lg-1 ${aboutStyle.about_icons}`}>
              <div className={`col-1 ${aboutStyle.vertical_line}`}></div>
              <IconShow
                path="mailto:azammoshiul8@gmail.com"
                className={`${aboutStyle.side_icon}`}
                src="assets/icons/about-icons/email.svg"
              />
              <IconShow
                path="https://bd.linkedin.com/in/moshiulazamm"
                className={`${aboutStyle.side_icon}`}
                src="assets/icons/about-icons/linkedin.svg"
              />
              <IconShow
                path="https://github.com/moshiul45"
                className={`${aboutStyle.side_icon}`}
                src="assets/icons/about-icons/github.svg"
              />
              <IconShow
                path="https://www.researchgate.net/profile/Md-Azam-28"
                className={`${aboutStyle.side_icon}`}
                src="assets/icons/about-icons/researchgate.svg"
              />
            </div>
          </div>
        </div>
      </div>
      <HeadLine title="#INTERESTS" typography="InterestS" />
      <div className={`row ${aboutStyle.Interest}`}>
        <InterestCard
          img="assets/icons/interest-icons/software_engineering.png"
          title="Software Engineering"
        />{" "}
        <InterestCard
          img="assets/icons/interest-icons/problem_solving.png"
          title="Problem Solving"
        />{" "}
        <InterestCard
          img="assets/icons/interest-icons/cloud.png"
          title="Cloud Computing"
        />{" "}
        <InterestCard
          img="assets/icons/interest-icons/networking.png"
          title="Computer Networking"
        />{" "}
        <InterestCard
          img="assets/icons/interest-icons/blockchain.png"
          title="Blockchain"
        />{" "}
        <InterestCard
          img="assets/icons/interest-icons/R&D.png"
          title="Research & Development"
        />{" "}
      </div>
    </div>
  );
};

export default About;
